import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _generateSlugRequest = {};
var _generateSlugResponse = { app: '_v1App' };
var _getNamespaceSuggestionByNameRequest = {};
var _getNamespaceSuggestionByNameResponse = {};
var _getNamespaceSuggestionRequest = {};
var _getNamespaceSuggestionResponse = {};
var _queryAppRequest = {};
var _queryAppResponse = { apps: '_v1App' };
var _setAppOwnerRequest = {};
var _setAppOwnerResponse = { app: '_v1App' };
var _setNamespaceRequest = {};
var _setNamespaceResponse = {};
var _setPrivateAppRequest = {};
var _setPrivateAppResponse = { app: '_v1App' };
var _updateAppRequest = { mask: 'google.protobuf.FieldMask', app: '_v1App' };
var _updateAppResponse = { app: '_v1App' };
var _v1App = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _v1CreateAppRequest = { app: '_v1App' };
var _v1CreateAppResponse = { app: '_v1App' };
var _v1GetAppRequest = {};
var _v1GetAppResponse = { app: '_v1App' };
function resolveWixDevcenterAppsV1AppsServiceUrl(opts) {
    var domainToMappings = {
        'editor._base_domain_': [
            {
                srcPath: '/apps-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/apps-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/apps-service',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/apps-service',
                destPath: '',
            },
            {
                srcPath: '/apps-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/apps-service',
                destPath: '',
            },
            {
                srcPath: '/apps-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/apps-service',
                destPath: '',
            },
            {
                srcPath: '/apps-service',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/apps-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/apps-service',
                destPath: '/api',
            },
            {
                srcPath: '/apps-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/apps-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new App */
export function createApp(payload) {
    var _a = serializer(_v1CreateAppRequest, {
        _v1App: _v1App,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1CreateAppResponse, { _v1App: _v1App }).fromJSON;
    function __createApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'POST',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.CreateApp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createApp.fromReq = fromReq;
    __createApp.__isAmbassador = true;
    return __createApp;
}
/** Get an App by id */
export function getApp(payload) {
    var _a = serializer(_v1GetAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1GetAppResponse, { _v1App: _v1App }).fromJSON;
    function __getApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'GET',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.GetApp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps/{appId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getApp.fromReq = fromReq;
    __getApp.__isAmbassador = true;
    return __getApp;
}
/**
 * Update an App, supports partial update
 * Pass the latest `revision` for a successful update
 */
export function updateApp(payload) {
    var _a = serializer(_updateAppRequest, {
        _v1App: _v1App,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAppResponse, { _v1App: _v1App }).fromJSON;
    function __updateApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'PATCH',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.UpdateApp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps/{app.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateApp.fromReq = fromReq;
    __updateApp.__isAmbassador = true;
    return __updateApp;
}
/** Set the slug of the app */
export function generateSlug(payload) {
    var _a = serializer(_generateSlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateSlugResponse, { _v1App: _v1App }).fromJSON;
    function __generateSlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'PATCH',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.GenerateSlug',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps/{appId}/generate-slug',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateSlug.fromReq = fromReq;
    __generateSlug.__isAmbassador = true;
    return __generateSlug;
}
/**
 * Get namespace suggestion using the Application's Account or Company.
 * When using Company and the Company Name is empty, fallback to Account Name.
 */
export function getNamespaceSuggestion(payload) {
    var _a = serializer(_getNamespaceSuggestionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getNamespaceSuggestionResponse, {}).fromJSON;
    function __getNamespaceSuggestion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'GET',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.GetNamespaceSuggestion',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps/{appId}/suggest-namespace',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getNamespaceSuggestion.fromReq = fromReq;
    __getNamespaceSuggestion.__isAmbassador = true;
    return __getNamespaceSuggestion;
}
/**
 * Get namespace suggestion using the Application's Account or Company.
 * When using Company and the Company Name is empty, fallback to Account Name.
 */
export function getNamespaceSuggestionByName(payload) {
    var _a = serializer(_getNamespaceSuggestionByNameRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getNamespaceSuggestionByNameResponse, {}).fromJSON;
    function __getNamespaceSuggestionByName(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'GET',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.GetNamespaceSuggestionByName',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps/suggest-namespace-by-name',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getNamespaceSuggestionByName.fromReq = fromReq;
    __getNamespaceSuggestionByName.__isAmbassador = true;
    return __getNamespaceSuggestionByName;
}
/**
 * Set the app namespace using the Application's Account or Company.
 * The namespace can ONLY be set once so it will fail if the namespace already exist.
 */
export function setNamespace(payload) {
    var _a = serializer(_setNamespaceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setNamespaceResponse, {}).fromJSON;
    function __setNamespace(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'PATCH',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.SetNamespace',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps/{appId}/set-namespace',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setNamespace.fromReq = fromReq;
    __setNamespace.__isAmbassador = true;
    return __setNamespace;
}
/** Query Apps using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryApp(payload) {
    var _a = serializer(_queryAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAppResponse, { _v1App: _v1App }).fromJSON;
    function __queryApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'POST',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.QueryApp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryApp.fromReq = fromReq;
    __queryApp.__isAmbassador = true;
    return __queryApp;
}
/**
 * Sets an app as private
 * @deprecated Will be removed on 2025-11-01.
 */
export function setPrivateApp(payload) {
    var _a = serializer(_setPrivateAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setPrivateAppResponse, { _v1App: _v1App }).fromJSON;
    function __setPrivateApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'POST',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.SetPrivateApp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps/set-private-app/{appId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setPrivateApp.fromReq = fromReq;
    __setPrivateApp.__isAmbassador = true;
    return __setPrivateApp;
}
/** Sets the account of the app */
export function setAppOwner(payload) {
    var _a = serializer(_setAppOwnerRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setAppOwnerResponse, { _v1App: _v1App }).fromJSON;
    function __setAppOwner(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app',
            method: 'PATCH',
            methodFqn: 'wix.devcenter.apps.v1.AppsService.SetAppOwner',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixDevcenterAppsV1AppsServiceUrl({
                protoPath: '/v1/apps/{appId}/set-owner/{accountId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setAppOwner.fromReq = fromReq;
    __setAppOwner.__isAmbassador = true;
    return __setAppOwner;
}
//# sourceMappingURL=http.impl.js.map